// This file is autogenerated by default-tables.mjs

/**
 * CSV columns: Company name, Company registration number, Country, Country ISO Code, Reason of blacklist, Added at, Risk level
 */
export const DEFAULT_TABLE_COMPANY_BLACKLIST = {
  columns: [
    'Company name',
    'Company registration number',
    'Country',
    'Country ISO Code',
    'Reason of blacklist',
    'Added at',
    'Risk level',
  ],
  entries: [
    [
      'Acme Holdings Ltd',
      '123456789',
      'Afghanistan',
      'AF',
      'Sanctioned for financing terrorism',
      '2024-11-10',
      'Prohibited',
    ],
  ],
} as const;
